export default "__VITE_ASSET__dkpyCRds__"